// Inline-style override for turning a `tertiary` Button into a compact
// 32×24 icon button with a subtle border. Used by the settings tables.
// The height is mirrored by --open-calendar-button-height in
// GanttWeekHeader.module.css, which sizes the week header around it.
// TODO: switch to qampo-ui-library's IconButton once it's cleaned up — right
// now it bakes in a non-transparent background and hover/focus border styles
// that don't match our design, and its preset sizes (24×24, 38×38) don't fit.
export const tertiaryIconButtonStyle: React.CSSProperties = {
  width: 32,
  height: 24,
  padding: 0,
  border: '1px solid var(--color-border-primary)'
};
